<template>
		<div class="content">
      <Header></Header>
      <div class="nav">
      	<span class="">{{$t('language')}}</span>
      </div>
			<div class="information language-bg">
        <div>
          <div class="ac">{{$t('PickLanguage')}}</div>
          <div class="en-list mt30 fw7">
            <div class="title2" :class="{'active':isShow=='bur'}" @click="getLang(2,'bur')"><img src="../../static/images/en1.png"></div>
            <div class="title2 app-en" :class="{'active':isShow=='en'}" @click="getLang(2,'en')"><img src="../../static/images/en.png"></div>
          </div><!-- English မြန်မာ -->
          <div class="ac mt50">
            <button class="btn1 btn-blue fw7" style="padding: 10px 20px;" @click="getLang(1)">{{$t('change')}}</button>
          </div>
        </div>
			</div>
		</div>
</template>
<script>
import Header from '../components/header'
export default {
    components:{
		Header
    },
    data() {
      return {
        list:[],
        lang:'',
        isShow:'bur',
      }
    },
	created(){
    if(localStorage.getItem('lang')){
      this.isShow = localStorage.getItem('lang')
    }
	},
    methods: {
      back(){
        this.$router.go(-1);
      },
      getLang(type,lang){
        if(type==1){
          localStorage.setItem('lang',this.lang)
          this.$router.push({path:'/',query:{}});
          location.reload()
        }else{
          this.isShow = lang
          this.lang = lang
        }
      },
    }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/language.vue